"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = exports.openCompanyPropertyDefaultsModal = exports.openOwnerPropertyDefaultsModal = exports.openContactPropertyDefaultsModal = exports.openStylesheetSelectModal = exports.ModalActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var ModalActionTypes = (0, _namespacedKeyMirror.default)({
  CLOSE_MODAL: null,
  OPEN_STYLESHEET_SELECT_MODAL: null,
  OPEN_CONTACT_PROPERTY_DEFAULTS_MODAL: null,
  OPEN_COMPANY_PROPERTY_DEFAULTS_MODAL: null,
  OPEN_OWNER_PROPERTY_DEFAULTS_MODAL: null
}, _UrlPathParams.PAGES);
exports.ModalActionTypes = ModalActionTypes;
var openStylesheetSelectModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_STYLESHEET_SELECT_MODAL);
exports.openStylesheetSelectModal = openStylesheetSelectModal;
var openContactPropertyDefaultsModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_CONTACT_PROPERTY_DEFAULTS_MODAL);
exports.openContactPropertyDefaultsModal = openContactPropertyDefaultsModal;
var openOwnerPropertyDefaultsModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_OWNER_PROPERTY_DEFAULTS_MODAL);
exports.openOwnerPropertyDefaultsModal = openOwnerPropertyDefaultsModal;
var openCompanyPropertyDefaultsModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_COMPANY_PROPERTY_DEFAULTS_MODAL);
exports.openCompanyPropertyDefaultsModal = openCompanyPropertyDefaultsModal;
var closeModal = (0, _fluxActions.createAction)(ModalActionTypes.CLOSE_MODAL);
exports.closeModal = closeModal;